"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var moment = require('moment');

var ShineShipping = require('../../shipping/ShineShipping');

var users = require('../../config/users.json');

function parsePrintingType(type) {
  if (type.match(/super/i)) {
    return '1 DAY';
  }

  if (type.match(/rush/i)) {
    if (type.match(/- 2/)) {
      return '2 DAY';
    }

    return 'RUSH';
  }

  return 'STD';
}

module.exports = function (params) {
  var designer_id;

  if (params.designer) {
    Object.keys(users).forEach(function (id) {
      // trying to match the selected name to the user id.
      if (users[id].name.toLowerCase() === params.designer.replace(/\./g, '').toLowerCase()) {
        designer_id = id;
      }
    });
  }

  var order = _objectSpread(_objectSpread({}, params), {}, {
    designer_id: designer_id,
    oid: params.oid,
    order_date: moment(params.order_date).toISOString(),
    event_date: params.event_date ? moment(params.event_date, 'MM/DD/YYYY').hours(12).toISOString() : null,
    email: params.email,
    products: params.products,
    printing_type: parsePrintingType(params.printing_type),
    primary_shipping_address: {
      telephone: params.telephone,
      lastname: params.lastname,
      firstname: params.firstname,
      address1: params.address1,
      address2: params.address2,
      city: params.city,
      state: params.state,
      zip: params.zip,
      country: params.country
    },
    shipping_service: ShineShipping.instance().parseShippingServiceFromVersionZero(params.shipping_type, params.order_date, moment(params.order_date).toISOString()),
    tax_rate: params.tax_rate,
    free_shipping: params.shipping_type.match(/\$0.00/),
    client_payment: parseFloat(params.total_price, 10)
  });

  return order;
};